import { Box, Flex, useDisclosure, useBreakpointValue } from '@chakra-ui/react';
import { Outlet } from 'react-router-dom';
import AdminSidebar from './AdminSidebar';
import AdminHeader from './AdminHeader';
import ErrorBoundary from './ErrorBoundary';

const AdminLayout = () => {
  const { isOpen, onToggle } = useDisclosure();
  // Use Chakra's useBreakpointValue to detect mobile view
  const isMobileView = useBreakpointValue({ base: true, md: false }) ?? false;

  return (
    <Flex h="100vh">
      <AdminSidebar 
        isOpen={isOpen} 
        isMobileView={isMobileView}
        onClose={onToggle}
      />
      
      <Box flex="1" overflow="auto">
        <AdminHeader onMenuClick={onToggle} />
        
        <Box as="main" p={6}>
          <ErrorBoundary>
            <Outlet />
          </ErrorBoundary>
        </Box>
      </Box>
    </Flex>
  );
};

export default AdminLayout;